module.exports = __webpack_public_path__ + "fb-share-5a383d9406ceb760546d.svg";